import {
  GET_SELF_EVALUATION_LIST,
} from '../../modules/constants';

// ------------------------------------
// Actions
// ------------------------------------

export function getSelfEvaluationList(value = {}) {
  return {
    type: GET_SELF_EVALUATION_LIST,
    payload: value,
  };
}